import React, { FC, BaseHTMLAttributes, ReactElement } from "react";

import classNames from "classnames";

import { StyledChoose } from "./Styles";

export interface IChooseProps extends BaseHTMLAttributes<HTMLButtonElement> {
  /** Children type of node or string */
  children: ReactElement | string;
  /** Disabled prop */
  disabled?: boolean;
  /** Active prop */
  active?: boolean;
  /** CSS classes */
  className?: string;
  /** Button type */
  type?: "button" | "submit" | "reset";
}

/**
 * Choose component
 */
export const Choose: FC<IChooseProps> = ({
  children,
  disabled = false,
  active = false,
  className,
  type = "button",
  ...args
}) => {
  return (
    <StyledChoose
      disabled={disabled}
      className={classNames("c-choose", className)}
      active={active}
      type={type}
      {...args}
    >
      {children}
    </StyledChoose>
  );
};

Choose.displayName = "Choose";
